module.exports = __webpack_public_path__ + "img/amibo1.6359e9d2.png";